import { RefObject } from 'react';
import { useLoadMapImages } from 'react-give-me-map';
import { MapRef } from 'react-map-gl';

export const DEFAULT_MAP_IMAGES = {
    locationMarkerOrange:
        'https://dekba9e71gqjn.cloudfront.net/200/d82500fe-7b70-4fea-9b40-137dc34d7159.png',
    locationMarkerGenerated:
        'https://dekba9e71gqjn.cloudfront.net/200/6e9d935f-f6a3-488b-a99c-fa124ab89050.png',
    bmDemoExit: 'https://dvtqxks0zalev.cloudfront.net/ed5d481f-9829-4ff0-b879-133d8880d02e.png',
    bmDemoToilet: 'https://dvtqxks0zalev.cloudfront.net/42856802-9bef-4813-8bf6-b3a3a798470b.png',
    bmDemoRedPin: 'https://dvtqxks0zalev.cloudfront.net/cc0fff38-a1b9-4e98-9cbe-9d5d848b4ac8.png',
    bmDemoRedMarker:
        'https://dvtqxks0zalev.cloudfront.net/bf801acd-80aa-45e5-8939-8b5caf57aca1.png',
    bmDemoGoldPin: 'https://dvtqxks0zalev.cloudfront.net/4c1a20da-cc8f-422a-b987-f1a2fbb7ede4.png',
    bmDemoGoldMarker:
        'https://dvtqxks0zalev.cloudfront.net/af1c4581-d66d-44d4-9ae5-5ee515e577c5.png',
    bmDemoLogo: 'https://dvtqxks0zalev.cloudfront.net/053a4e10-0031-4c6d-8249-795656c439cc.png',
    indoorStandGreen:
        'https://dvtqxks0zalev.cloudfront.net/200/e09fa7be-776b-46e5-80af-4231e8fed303.png',
    indoorStandRed:
        'https://dvtqxks0zalev.cloudfront.net/200/cdf23436-3867-4cb2-a3ce-75eb45955958.png'
};

export const usePreloadDefaultImages = (mapRef: RefObject<MapRef>) => {
    useLoadMapImages({
        mapRef,
        imageUrls: Object.values(DEFAULT_MAP_IMAGES)
    });
};
